import React from "react";
import SupportChat from "components/chrome/main_view/support_chat";

export default function WorkforceBadPermissions() {
  return (
    <div>
      <p>
        Make sure that your account administrator has enabled you to manage
        Users and Workforce.
      </p>
      <br />
      <p>
        If you believe you have access and are still having issues, chat with us
        at <SupportChat />.
      </p>
    </div>
  );
}
